import PropTypes from 'prop-types';
import { useForm, useWatch } from 'react-hook-form';
import { useNodeById } from '@/stores/analysisStore';
import { FormProvider } from 'react-hook-form';

import debounce from 'debounce';
import LevelizationForm from '@/components/core/LevelizationForm';
import { ModuleSelect } from '@/components/core/form/ModuleSelect';
import { useEffect } from 'react';

const SensitivityForm = ({ defaultValues, onSubmit }) => {
  const methods = useForm({ defaultValues });
  const { handleSubmit, control, reset } = methods;
  const debouncedSubmit = debounce(() => handleSubmit(onSubmit)(), 100);
  const [nodeId, levelizeBy, levelizeUnit, levelizableIos] = useWatch({
    control,
    name: ['nodeId', 'levelizeBy', 'levelizeUnit', 'levelizableIos'],
    defaultValue: defaultValues,
  });

  const node = useNodeById(nodeId);

  useEffect(() => {
    reset(defaultValues);
  }, [reset, defaultValues]);

  return (
    <FormProvider {...methods}>
      <div className="group node">
        <form onChange={debouncedSubmit}>
          <div className="mt-2 grid grid-cols-6 gap-2">
            <ModuleSelect />
            <LevelizationForm
              node={node}
              levelizableIos={levelizableIos}
              levelizeBy={levelizeBy}
              levelizeUnit={levelizeUnit}
            />
          </div>
        </form>
      </div>
    </FormProvider>
  );
};

SensitivityForm.propTypes = {
  params: PropTypes.arrayOf(PropTypes.object),
  defaultValues: PropTypes.object,
  onSubmit: PropTypes.func,
};

export default SensitivityForm;
